import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TransitionGroup } from 'react-transition-group';

import {
    goToFindLocalRep,
    hideFindRepPopup,
    loadLocalRep,
    onFindYourRep,
    selectAction
} from '../LocalRep/actions';

import { onGoToNextActionInsideCard, setOverlayPartnerVisible } from '../Widget/actions';

import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';
import WidgetHeader from '../Widget/WidgetHeader';

import { Container } from '../DefaultStyles/Details';
import {
    Body,
    Content,
    Description,
    Details,
    DetailsContainer,
    Footer,
    Title
} from '../DefaultStyles/Shared';

import { AutoScalingButtonSet } from '../../components/Buttons/AutoScalingButtonSet';
import { FindRepLink } from '../../components/LocalRep/LocalRep';
import { isLongText } from '../../components/Shared/commonFunctions.js';
import { MultiImageBlock } from '../../components/Image/MultiImageBlock';
import AnswerButton from '../../components/Assessment/AnswerButton';
import CssTransition from '../../components/Transition/CssTransition';
import FindLocalRepPopup from '../../components/LocalRep/FindLocalRepPopup';
import ShareDrawer from '../../components/ShareDrawer';

import { LocalRepState } from '../../utils/enums';
import { Placeholders } from '../../utils/fillDynamicText';
import {
    joinEnglish,
    relevantRepresentatives
} from '../../utils/localRepresentative/parser';
import { copyFor } from '../../copy/copy';

import defaultImage from '../../assets/images/localRepDefault.jpg';

class TargetedMultiActionDetails extends React.Component {
    constructor(props) {
        super(props);
        if (!props.localRepFound && props.useLocalRepresentative) props.loadLocalRep();
    }

    generateSubheading() {
        if (this.props.cardSubHeading) {
            return this.props.cardSubHeading;
        } else if (this.props.localRepFound && this.props.localRepresentatives !== '') {
            return this.props.localRepresentatives;
        } else if (!this.props.isLocalRepLoading) {
            return (
                <FindRepLink onClick={this.props.onFindYourRep}>
                    {copyFor('findReps', 'clickToFind')}
                </FindRepLink>
            );
        }
    }

    render() {
        return (
            <Container>
                <Overlay />
                <OverlayPublisher />
                <OverlayPartner transitionType="right-to-left" />
                <Body isBlured={this.props.showFindYouRepPopup}>
                    <WidgetHeader />
                    <Content
                        isContactAction={false}
                        useLocalRepresentative={this.props.useLocalRepresentative}
                        isSingleAction={false}
                    >
                        <Title
                            isLocalRepLoading={this.props.isLocalRepLoading}
                            isLongText={isLongText(this.props.cardHeading, 60)}
                            isExtraLongText={isLongText(this.props.cardHeading, 95)}
                            onClick={e =>
                                this.props.setOverlayPartnerVisible(true, e, false)
                            }
                            dangerouslySetInnerHTML={{ __html: this.props.cardHeading }}
                        />
                        <DetailsContainer>
                            <MultiImageBlock
                                isLongTitle={isLongText(this.props.cardHeading, 40)}
                                isLocalRepLoading={this.props.isLocalRepLoading}
                                imgSources={
                                    this.props.useLocalRepresentative
                                        ? this.props.localRepImages.length > 0
                                            ? this.props.localRepImages
                                            : [defaultImage]
                                        : this.props.pictureUrl
                                        ? [this.props.pictureUrl]
                                        : [defaultImage]
                                }
                            />
                            <Details
                                hasPhoto={
                                    this.props.useLocalRepresentative ||
                                    this.props.pictureUrl
                                }
                            >
                                <Description
                                    isTargetedMultiAction={true}
                                    isLocalRepLoading={this.props.isLocalRepLoading}
                                    isSingleAction={this.props.actions.length === 1}
                                    isLongText={isLongText(this.props.cardSubHeading, 90)}
                                    isExtraLongText={isLongText(
                                        this.props.cardSubHeading,
                                        160
                                    )}
                                    onClick={e =>
                                        this.props.setOverlayPartnerVisible(
                                            true,
                                            e,
                                            false
                                        )
                                    }
                                    dangerouslySetInnerHTML={{
                                        __html: this.generateSubheading()
                                    }}
                                />
                            </Details>
                        </DetailsContainer>
                    </Content>
                    <AutoScalingButtonSet>
                        {this.props.actions.map(a => (
                            <AnswerButton
                                text={a.label.toUpperCase()}
                                useLoadingSpinner={true}
                                key={a.identifier}
                                data-action={a.identifier}
                                onClick={
                                    !this.props.useLocalRepresentative ||
                                    (this.props.localRepFound &&
                                        this.props.localRepresentatives !== '')
                                        ? () => {
                                              this.props.selectAction(a.identifier);
                                              return this.props.onGoToNextActionInsideCard(
                                                  a.identifier,
                                                  a.type,
                                                  false
                                              );
                                          }
                                        : () => {
                                              this.props.selectAction(a.identifier);
                                              this.props.goToFindLocalRep(
                                                  a.identifier,
                                                  'targetedMultiAction'
                                              );
                                          }
                                }
                            />
                        ))}
                    </AutoScalingButtonSet>
                </Body>
                <Footer>
                    <ShareDrawer backgroundColor={'#fff'} />
                </Footer>
                <TransitionGroup>
                    {this.props.showFindYouRepPopup && (
                        <CssTransition key="alert" in={this.props.showFindYouRepPopup}>
                            <FindLocalRepPopup
                                hideFindRepPopup={this.props.hideFindRepPopup}
                                onSubmit={data =>
                                    this.props.loadLocalRep(
                                        data,
                                        true,
                                        this.props.showOnlySenators
                                    )
                                }
                            />
                        </CssTransition>
                    )}
                </TransitionGroup>
            </Container>
        );
    }
}

TargetedMultiActionDetails.propTypes = {
    showOnlySenators: PropTypes.bool.isRequired,
    localRepresentatives: PropTypes.string.isRequired,
    cardHeading: PropTypes.string.isRequired,
    cardSubHeading: PropTypes.string.isRequired,
    onFindYourRep: PropTypes.func.isRequired,
    onGoToNextActionInsideCard: PropTypes.func.isRequired,
    goToFindLocalRep: PropTypes.func.isRequired,
    hideFindRepPopup: PropTypes.func.isRequired,
    loadLocalRep: PropTypes.func.isRequired,
    showFindYouRepPopup: PropTypes.bool.isRequired,
    localRepImages: PropTypes.array,
    pictureUrl: PropTypes.string,
    actions: PropTypes.array.isRequired,
    localRepFound: PropTypes.bool.isRequired,
    isLocalRepLoading: PropTypes.bool,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    selectAction: PropTypes.func.isRequired,
    useLocalRepresentative: PropTypes.bool
};

const pictureUrl = state => {
    const picture = state.widget.pictures.find(
        a =>
            a.recipientPictureId ===
            state.widget.cards[state.widget.activeAction.order - 1].recipientPictureId
    );
    return (picture || {}).pictureUrl;
};

export default connect(
    state => {
        const reps = state.localRep.localRepData
            ? relevantRepresentatives(
                  state.widget.cards[state.widget.activeAction.order - 1]
                      .localRepresentativeState,
                  state.localRep.localRepData.representative
              )
            : [];
        const repNames = !!state.localRep.localRepData.representative
            ? joinEnglish(
                  reps.map(
                      rep =>
                          `${rep.shortName} (${
                              rep.level === 2
                                ? `${rep.partyIdentifier}-${state.localRep.localRepData.state}` //eslint-disable-line
                                : `${state.localRep.localRepData.state}-${state.localRep.localRepData.district}` //eslint-disable-line
                          })`
                  )
              )
            : null;

        return {
            showOnlySenators:
                state.widget.cards[state.widget.activeAction.order - 1]
                    .localRepresentativeState === LocalRepState.senators,
            localRepresentatives: repNames || '',
            cardHeading: state.widget.cards[state.widget.activeAction.order - 1].heading
                .replace(
                    new RegExp(Placeholders.LocalRepresentative, 'g'),
                    repNames || 'Speakable'
                )
                .replace(
                    new RegExp(Placeholders.TwitterMentionPlaceholder, 'g'),
                    repNames || '@Speakable'
                ),
            cardSubHeading: state.widget.cards[
                state.widget.activeAction.order - 1
            ].subHeading
                .replace(
                    new RegExp(Placeholders.LocalRepresentative, 'g'),
                    repNames || 'Speakable'
                )
                .replace(
                    new RegExp(Placeholders.TwitterMentionPlaceholder, 'g'),
                    repNames || '@Speakable'
                ),
            isLocalRepLoading: state.localRep.isLocalRepLoading,
            localRepFound: state.localRep.localRepData.representative !== undefined,
            pictureUrl: pictureUrl(state),
            localRepImages: !!state.localRep.localRepData.representative
                ? reps.map(rep => rep.photoUrl || defaultImage)
                : [],
            showFindYouRepPopup: state.localRep.showFindYouRepPopup,
            useLocalRepresentative:
                state.widget.activeAction.localRepresentativeState !==
                LocalRepState.disabled,
            actions: state.widget.actions
                .filter(function(a) {
                    return state.widget.activeAction.type === 'petition'
                        ? a.id === state.widget.activeAction.id
                        : a.order === state.widget.activeAction.order &&
                              a.order.type === state.widget.activeAction.order.type;
                })
                .map(a => ({
                    label:
                        a.customButtonText !== undefined
                            ? a.customButtonText
                            : copyFor('buttons', 'start', a.type),
                    identifier: a.identifier,
                    type: a.type,
                    name: a.name,
                    useLocalRepresentative:
                        state.widget.activeAction.localRepresentativeState !==
                        LocalRepState.disabled,
                    position: state.widget.cards[
                        state.widget.activeAction.order - 1
                    ].actions.indexOf(a),
                    localRepTwitterMention: !!state.localRep.localRepData.representative
                        ? joinEnglish(
                              reps.map(rep => '@' + (rep.twitterMention || rep.fullName))
                          )
                        : '@Speakable'
                }))
                .slice(0, 3)
        };
    },
    {
        goToFindLocalRep,
        hideFindRepPopup,
        loadLocalRep,
        onFindYourRep,
        onGoToNextActionInsideCard,
        selectAction,
        setOverlayPartnerVisible
    }
)(TargetedMultiActionDetails);



// WEBPACK FOOTER //
// ./src/containers/TargetedMultiAction/TargetedMultiActionDetails.jsx